<div [dir]="language == 'ar' ? 'rtl' : 'ltr'">
  <div *ngFor="let comp of homeComponents">
    <ng-container [ngSwitch]="comp.type">
      <app-hero-with-one-image *ngSwitchCase="'hero-with-one-image'" [data]="comp.details"></app-hero-with-one-image>

      <div class="" *ngSwitchCase="'text-with-image'">
        <app-text-with-image [data]="comp.details" [language]="language"
          [fileName]="comp.fileName"></app-text-with-image>
      </div>
      <div class="" *ngSwitchCase="'cards-with-frame'">
        <app-grid-cards-with-frame [data]="comp" [language]="language"
          [fileName]="comp.fileName"></app-grid-cards-with-frame>
      </div>
      <div class="mx-3 mx-md-5" *ngSwitchCase="'image-with-text'">
        <app-image-with-text [data]="comp" [language]="language" [fileName]="comp.fileName"></app-image-with-text>
      </div>
      <div class="" *ngSwitchCase="'grid-text-with-image'">
        <app-grid-text-with-image [data]="comp.details" [language]="language"
          [fileName]="comp.fileName"></app-grid-text-with-image>
      </div>
      <div class="">
        <app-our-news *ngSwitchCase="'our-news'" [language]="language"></app-our-news>
      </div>

    </ng-container>

  </div>
</div>